import { BaseErrorStatus } from '@app/api/enums/base-error-status.enum';

export enum BaseAuthStatus {
  FailedUserUnknown = 'FAILED_USER_UNKNOWN',
  FailedUserDisabled = 'FAILED_USER_DISABLED',
  FailedWrongPassword = 'FAILED_WRONG_PASSWORD',
  FailedResetPasswordTokenExpired = 'FAILED_RESET_PASSWORD_TOKEN_EXPIRED',
  FailedNewPasswordRejected = 'FAILED_NEW_PASSWORD_REJECTED',
  FailedMissingToken = 'FAILED_MISSING_TOKEN',
}

export enum TwofaSetupStatus {
  TwofaSetup = 'TWOFA_SETUP',
  TwofaRequired = 'TWOFA_REQUIRED',
  /**
   * @description Only for 2fa logic
   */
  TwofaWrongCode = 'TWOFA_WRONG_CODE',
}

export type AuthErrorStatus = BaseErrorStatus | BaseAuthStatus | TwofaSetupStatus;
